var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"home_btn",on:{"click":_vm.entoSouhuo}},[_c('i',{staticClass:"iconfont icon-shouye"})])])}
var staticRenderFns = []

export { render, staticRenderFns }